export const seoConfig = {
  titleTemplate: '%s',
  defaultTitle: 'SpotMe | Marketplace de Bodegas, Estacionamientos y Naves',
  description:
    'SpotMe es un marketplace donde encuentras todo tipo de espacios en renta en México - minibodegas, bodegas comerciales, estacionamientos y naves industriales.',
  openGraph: {
    type: 'website',
    // es_MX, not es_ES — SpotMe is a Mexico-only marketplace. Keep in sync with
    // `toOgLocale()` in src/utils/seo.ts, which pages use to map their own
    // `locale` prop (a bare `es` is an invalid og:locale and gets dropped).
    locale: 'es_MX',
    site_name: 'SpotMe',
    images: [
      {
        url: 'https://www.spotme.mx/images/cover.png',
        width: 1200,
        height: 628,
        alt: 'SpotMe - Marketplace de espacios en renta'
      }
    ]
  },
  twitter: {
    handle: '@spotmemx',
    site: '@spotmemx',
    cardType: 'summary_large_image'
  },
  facebook: { appId: '3232029973724272' },
  additionalLinkTags: [
    {
      rel: 'icon',
      type: 'image/png',
      href: '/logos/android-chrome-192x192.png',
      sizes: '192x192'
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/logos/android-chrome-512x512.png',
      sizes: '512x512'
    },
    { rel: 'apple-touch-icon', href: '/logos/apple-touch-icon.png' },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/logos/favicon-48x48.png',
      sizes: '48x48'
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/logos/favicon-96x96.png',
      sizes: '96x96'
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/logos/favicon-16x16.png',
      sizes: '16x16'
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/logos/favicon-32x32.png',
      sizes: '32x32'
    },
    { rel: 'icon', type: 'image/x-icon', href: '/logos/favicon.ico' },
    { rel: 'icon', type: 'image/svg+xml', href: '/logos/favicon.svg' },
    { rel: 'preconnect', href: 'https://server.spotme.mx' },
    // Serves the Static Maps preview, which is the LCP element on /search and
    // on every city/pillar page. It was costing a cold DNS + TLS handshake on
    // the critical path — measured 2026-08-31, the only preconnected origin
    // was `server.spotme.mx`. Deliberately NO `crossOrigin`: the preview is a
    // plain <img>, not a CORS fetch, and a credentialed preconnect would warm
    // a connection pool the image then doesn't use.
    { rel: 'preconnect', href: 'https://maps.googleapis.com' },
    { rel: 'manifest', href: '/webmanifest.json' }
  ],
  additionalMetaTags: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
    { name: 'theme-color', content: '#FFFFFF' },
    { name: 'format-detection', content: 'telephone=no' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
    { name: 'apple-mobile-web-app-title', content: 'SpotMe' },
    {
      name: 'google-site-verification',
      content: '8_Ek6RgXQEQP_KAeF0k-7o8z66LFCJyfhVL6YuNNmlY'
    },
    {
      name: 'google-site-verification',
      content: 'ki2iyqKFWF8wrYWOQNVD8lACrm_MRJqJy1ese5xJ2vI'
    }
  ]
}

/**
 * English overrides for the `DefaultSeo` fallback.
 *
 * `seoConfig` above is the ES default. Any page that does NOT render its own
 * `<NextSeo>` inherits that fallback — which meant `/en/`, `/en/search`,
 * `/en/guia-de-tamanos` and `/en/anfitrion` all shipped a Spanish `<title>`,
 * description and `og:locale` into the browser tab and every social share.
 *
 * The `/en` tree is deliberately `noindex, follow` (see `_app.tsx`), so this is
 * not an SEO-ranking fix — it is a "the tab and the WhatsApp/Slack unfurl are
 * in the right language" fix. Spread over `seoConfig` in `_app.tsx` when the
 * active locale is `en`.
 */
export const seoConfigEnOverrides = {
  defaultTitle: 'SpotMe | Storage, Parking & Warehouse Marketplace in Mexico',
  description:
    'SpotMe is a marketplace for every kind of rental space in Mexico — self-storage units, commercial warehouses, parking spots and industrial warehouses.',
  openGraph: {
    ...seoConfig.openGraph,
    locale: 'en_US',
    images: [
      {
        ...seoConfig.openGraph.images[0],
        alt: 'SpotMe - Marketplace for rental spaces'
      }
    ]
  }
}
